import {useContext} from 'react'
import {CustomLanding36252Context} from '../../reducer'
import {Container} from './components/Container'
import {Header} from './components/Header'
import {t} from '../../i18n'
import {Normal} from './components/Normal'

export const TermsAndConditions = () => {
  const [state] = useContext(CustomLanding36252Context)
  const tr = t[state.language]

  return (
    <Container>
      <Header>{tr.tcMainHeader}</Header>
      <Normal>{tr.tcMainIntro}</Normal>
      <Header>{tr.tcHead1}</Header>
      <Normal>{tr.tcPara11}</Normal>
      <Normal>{tr.tcPara12}</Normal>
      <Normal>{tr.tcPara13}</Normal>
      <Normal>{tr.tcPara14}</Normal>
      <Header>{tr.tcHead2}</Header>
      <Normal>{tr.tcPara21}</Normal>
      <Header>{tr.tcHead3}</Header>
      <Normal>{tr.tcPara31}</Normal>
      <Normal>{tr.tcPara32}</Normal>
      <Normal>{tr.tcPara33}</Normal>
      <Header>{tr.tcHead4}</Header>
      <Normal>{tr.tcPara41}</Normal>
      <Normal>{tr.tcPara42}</Normal>
      <Header>{tr.tcHead5}</Header>
      <Normal>{tr.tcPara51}</Normal>
      <Normal>{tr.tcPara52}</Normal>
      <Normal>{tr.tcPara53}</Normal>
      <br />
      <Normal>{tr.tcFinal}</Normal>
    </Container>
  )
}
